import { Link } from 'react-router-dom';
import { Button, Form, InputNumber } from 'antd';

import { useI18n } from '../../i18n';

export const FormActions = ({ info, cancelTo, submitting, submitLabel, disabled }) => {
  const { t } = useI18n();
  return (
    <div className='wm-form-actions'>
      {info && <div className='wm-form-actions__info'>{info}</div>}
      {cancelTo && (
        <Link to={cancelTo}>
          <Button>{t('common.cancel')}</Button>
        </Link>
      )}
      <Button type='primary' htmlType='submit' loading={submitting} disabled={disabled}>
        {submitLabel ?? t('common.save')}
      </Button>
    </div>
  );
};

const groupDigits = value =>
  value === undefined || value === null || value === ''
    ? ''
    : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const parseDigits = value => (value ? value.replace(/[\s\u00a0]/g, '') : value);

export const AmountInput = ({ suffix, ...props }) => (
  <InputNumber
    min={0}
    step={1}
    formatter={groupDigits}
    parser={parseDigits}
    addonAfter={suffix}
    inputMode='numeric'
    style={{ width: '100%' }}
    {...props}
  />
);

export const QtyRow = ({ name, title, meta, hidden, placeholder, requiredMessage, required = true }) => (
  <Form.Item noStyle shouldUpdate={(prev, next) => prev[name] !== next[name]}>
    {({ getFieldValue }) => (
      <div
        className={`wm-qty-row${Number(getFieldValue(name)) > 0 ? ' is-filled' : ''}`}
        style={hidden ? { display: 'none' } : undefined}
      >
        <div>
          <div className='wm-qty-row__name'>{title}</div>
          {meta && <div className='wm-qty-row__meta'>{meta}</div>}
        </div>
        <Form.Item name={name} rules={required ? [{ required: true, message: requiredMessage }] : undefined}>
          <AmountInput placeholder={placeholder} aria-label={title} />
        </Form.Item>
      </div>
    )}
  </Form.Item>
);
